import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

export function enableOrientation(object, settings) {

  if (settings.direction || settings.mirror) {

    signal.on('TOGGLE:left', (left) => {
      const { orientation, scale, stage, screen } = game.models.SizeModel.size
      const params = settings.orientation[orientation]

      if (orientation === 'land') {

        if (left && settings.direction) {
          object.x = stage.width - object.x - settings.width + 10
        }
        else {
          object.x = params.x + (params.h || 0) * (screen.width - stage.width * scale) / 2 / scale
        }

        if (left && settings.mirror) {
          object.scale.x = -1 * settings.scale
          object.x += settings.width
        }
        else if (!left && settings.mirror) {
          object.scale.x = settings.scale
        }

      }
    })
  }

  signal.on('RESIZE', function ({ orientation, scale, stage, screen }) {
    const params = settings.orientation[orientation]

    if (params) {
      object.visibility(true, 'orientation')

      if (params.scale) {
        object.scale.set(params.scale)//todo check
      }

      if (StoreageService.get('left') && orientation === 'land' && (settings.direction || settings.mirror)) {
        if (settings.direction && !settings.mirror) {
          object.x =  stage.width + 10 - settings.width - (params.x  + (params.h || 0) * (screen.width - stage.width * scale) / 2 / scale)
        }
        if (settings.direction && settings.mirror) {
          object.scale.x = -1 * settings.scale
          object.x = stage.width - (params.x + (params.h || 0) * (screen.width - stage.width * scale) / 2 / scale)
        }
        if (!settings.direction && settings.mirror) {
          object.scale.x = -1 * settings.scale
          object.x = settings.width + (params.x + (params.h || 0) * (screen.width - stage.width * scale) / 2 / scale)

        }
      }
      else {
        object.x =  params.x + (params.h || 0) * (screen.width - stage.width * scale) / 2 / scale

        if (settings.mirror) {
          object.scale.x = settings.scale
        }
      }

      object.y = params.y + (params.v || 0) * (screen.height - stage.height * scale) / 2 / scale
    }
    else {
      object.visibility(false, 'orientation')
    }
  })

  return object
}
